import axios from '@/libs/api.request'
import qs from 'qs'

export const getAllPermission = () => {
  return axios.request({
    url: 'permission/list',
    method: 'get'
  })
}

export const getPermissionList = (page, pageSize, keyword) => {
  return axios.request({
    url: 'permission/list',
    params: {
      page,
      pageSize,
      keyword
    },
    method: 'get'
  })
}

export const addPermission = (data) => {
  return axios.request({
    url: 'permission/add',
    data: data,
    method: 'post'
  })
}

export const delPermission = (id) => {
  return axios.request({
    url: `permission/delete/${id}`,
    method: 'delete'
  })
}

export const deleteCovertFace = (id) => {
  return axios.request({
    url: `covert_face/delete/${id}`,
    method: 'delete'
  })
}

export const deleteMergeVideo = (id) => {
  return axios.request({
    url: `merge_video/delete/${id}`,
    method: 'delete'
  })
}


export const endCheckSrt = (id) => {
  return axios.request({
    url: `check_srt/end/${id}`,
    method: 'put'
  })
}

export const endTranslateTask = (id) => {
  return axios.request({
    url: `translate_text_task/end/${id}`,
    method: 'put'
  })
}

export const resetTranslateTask = (id) => {
  return axios.request({
    url: `translate_text_task/reset/${id}`,
    method: 'put'
  })
}

export const endCovertAudio = (id) => {
  return axios.request({
    url: `make_audio/end/${id}`,
    method: 'put'
  })
}

export const endCovertFace = (id) => {
  return axios.request({
    url: `covert_face/end/${id}`,
    method: 'put'
  })
}

export const resetCovertFace = (id) => {
  return axios.request({
    url: `covert_face/reset/${id}`,
    method: 'put'
  })
}

export const endMergeVideo = (id) => {
  return axios.request({
    url: `merge_video/end/${id}`,
    method: 'put'
  })
}

export const resetMergeVideo = (id) => {
  return axios.request({
    url: `merge_video/reset/${id}`,
    method: 'put'
  })
}

export const resetAdvertisementVideo = (id) => {
  return axios.request({
    url: `advertisement_video/reset/${id}`,
    method: 'put'
  })
}

export const endAdvertisementVideo = (id) => {
  return axios.request({
    url: `advertisement_video/end/${id}`,
    method: 'put'
  })
}

export const endPushVideo = (id) => {
  return axios.request({
    url: `dy_video/end/${id}`,
    method: 'put'
  })
}


export const okPushVideo = (id) => {
  return axios.request({
    url: `dy_video/ok/${id}`,
    method: 'put'
  })
}

export const finishVideo = (id) => {
  return axios.request({
    url: `dy_video/finish/${id}`,
    method: 'put'
  })
}

export const editPermission = (data) => {
  return axios.request({
    url: `permission/edit/${data.id}`,
    data: data,
    method: 'put'
  })
}

export const getAllRole = () => {
  return axios.request({
    url: 'role/list',
    method: 'get'
  })
}

export const getRoleList = (page, pageSize, keyword) => {
  return axios.request({
    url: 'role/list',
    params: {
      page,
      pageSize,
      keyword
    },
    method: 'get'
  })
}

export const getRoleInfo = (id) => {
  return axios.request({
    url: 'role/info',
    params: {
      id
    },
    method: 'get'
  })
}

export const addRole = (data) => {
  return axios.request({
    url: 'role/add',
    data: data,
    method: 'post'
  })
}

export const delRole = (id) => {
  return axios.request({
    url: `role/delete/${id}`,
    method: 'delete'
  })
}

export const deleteShortVideoTask = (id) => {
  return axios.request({
    url: `role/deleteShortVideoTask/${id}`,
    method: 'delete'
  })
}

export const editRole = (data) => {
  return axios.request({
    url: `role/edit/${data.id}`,
    data: data,
    method: 'put'
  })
}


export const editUserBlack = (data, id) => {
  return axios.request({
    url: `dy_user/edit_user_black/${id}`,
    data: data,
    method: 'put'
  })
}

export const editUserMaxCount = (data, id) => {
  return axios.request({
    url: `dy_user/edit_user_max_count/${id}`,
    data: data,
    method: 'put'
  })
}

export const getAllFactory = () => {
  return axios.request({
    url: 'factory/list',
    method: 'get'
  })
}

// 获取OSS STS token
export const getOssSts = () => {
  return axios.request({
    url: 'short_video_task/get_oss_sts',
    method: 'get'
  })
}

export const getWxContacts = () => {
  return axios.request({
    url: 'dy/get_wx_contacts',
    method: 'get'
  })
}

export const getClassifys = (params) => {
  return axios.request({
    url: 'dy/get_classify',
    params: params,
    method: 'get'
  })
}

export const getTaskTypeList = (params) => {
  return axios.request({
    url: 'dy_task/list_task_type',
    params: params,
    method: 'get'
  })
}

export const getActionTypeList = (params) => {
  return axios.request({
    url: 'dy_task/list_action_type',
    params: params,
    method: 'get'
  })
}

export const listComment = (params) => {
  return axios.request({
    url: 'dy_comment/list_comment',
    params: params,
    method: 'get'
  })
}


export const getFactoryList = (page, pageSize, keyword) => {
  return axios.request({
    url: 'factory/list',
    params: {
      page,
      pageSize,
      keyword
    },
    method: 'get'
  })
}

export const getFactoryInfo = (id) => {
  return axios.request({
    url: 'factory/info',
    params: {
      id
    },
    method: 'get'
  })
}

export const getGptList = (params) => {
  return axios.request({
    url: 'dy/list_gpt',
    params: params,
    method: 'get'
  })
}

export const getAdvertisement = (params) => {
  return axios.request({
    url: 'dy/list_advertisement',
    params: params,
    method: 'get'
  })
}

export const getCommentStrategyList = (params) => {
  return axios.request({
    url: 'dy_strategy/list_comment',
    params: params,
    method: 'get'
  })
}


export const getCommentKeywordList = (params) => {
  return axios.request({
    url: 'dy_strategy/list_comment_keyword',
    params: params,
    method: 'get'
  })
}

export const editCommentKeyword = (data, id) => {
  return axios.request({
    url: `dy_strategy/edit_comment_keyword/${id}`,
    data: data,
    method: 'put'
  })
}

export const addCommentKeyword = (data) => {
  return axios.request({
    url: 'dy_strategy/add_comment_keyword',
    data: data,
    method: 'post'
  })
}

export const deleteCommentKeyword = (id) => {
  return axios.request({
    url: `dy_strategy/delete_comment_keyword/${id}`,
    method: 'delete'
  })
}

export const getClassifyOrg = (params) => {
  return axios.request({
    url: 'dy/list_org',
    params: params,
    method: 'get'
  })
}

export const editClassifyOrg = (data, id) => {
  return axios.request({
    url: `dy/edit_org/${id}`,
    data: data,
    method: 'put'
  })
}

export const getTagStandText = (params) => {
  return axios.request({
    url: 'dy_strategy/list_tag_stand',
    params: params,
    method: 'get'
  })
}

export const addTagStandText = (data) => {
  return axios.request({
    url: 'dy_strategy/add_tag_stand_text',
    data: data,
    method: 'post'
  })
}


export const editTagStandText = (data, id) => {
  return axios.request({
    url: `dy_strategy/edit_tag_stand_text/${id}`,
    data: data,
    method: 'put'
  })
}

export const editUserWechat = (data, id) => {
  return axios.request({
    url: `dy_user/edit_user_wechat/${id}`,
    data: data,
    method: 'put'
  })
}

export const deleteTagStandText = (id) => {
  return axios.request({
    url: `dy_strategy/delete_tag_stand_text/${id}`,
    method: 'delete'
  })
}

export const editUserTag = (data) => {
  return axios.request({
    url: 'dy_user/edit_user_tag',
    data: data,
    method: 'post'
  })
}

export const changeFollower = (data) => {
  return axios.request({
    url: 'dy_user/change_follower',
    data: data,
    method: 'post'
  })
}

export const deleteClassifyOrg = (id) => {
  return axios.request({
    url: `dy/delete_org/${id}`,
    method: 'delete'
  })
}

export const addClassifyOrg = (data) => {
  return axios.request({
    url: 'dy/add_org',
    data: data,
    method: 'post'
  })
}

export const listFlower = (params) => {
  return axios.request({
    url: 'dy_user/list_flowers',
    params: params,
    method: 'get'
  })
}

export const listLetter = (params) => {
  return axios.request({
    url: 'dy_letter/list',
    params: params,
    method: 'get'
  })
}

export const listDeleteComment = (params) => {
  return axios.request({
    url: 'dy_comment/get_delete_comments',
    params: params,
    method: 'get'
  })
}

export const listCommentMessage = (params) => {
  return axios.request({
    url: 'dy_comment/list',
    params: params,
    method: 'get'
  })
}

export const letterDetail = (params) => {
  return axios.request({
    url: 'dy_letter/letter_detail',
    params: params,
    method: 'get'
  })
}

export const makeVideoDetail = (params) => {
  return axios.request({
    url: 'covert_face/detail',
    params: params,
    method: 'get'
  })
}

export const listGptModel = () => {
  return axios.request({
    url: 'dy_strategy/list_gpt_model',
    method: 'get'
  })
}

export const getUserFaceLibrary = (params) => {
  return axios.request({
    url: 'dy_user/get_user_face_library',
    params: params,
    method: 'get'
  })
}

export const addUserFaceLibrary = (params) => {
  return axios.request({
    url: 'dy_user/add_user_face_library',
    data: params,
    method: 'post'
  })
}

export const deleteUserFaceLibrary = (id) => {
  return axios.request({
    url: `dy_user/delete_user_face_library/${id}`,
    method: 'delete'
  })
}

export const editUserFaceLibrary = (data, id) => {
  return axios.request({
    url: `dy_user/edit_user_face_library/${id}`,
    data: data,
    method: 'put'
  })
}

export const addCommentStrategy = (params) => {
  return axios.request({
    url: 'dy_strategy/add_comment_strategy',
    data: params,
    method: 'post'
  })
}

export const addUserExcel = (params) => {
  return axios.request({
    url: 'dy_user/add_user_excel',
    data: params,
    method: 'post'
  })
}

export const addStrateUser = (params) => {
  return axios.request({
    url: 'dy/add_user',
    data: params,
    method: 'post'
  })
}

export const editStrategyUser = (data, id) => {
  return axios.request({
    url: `dy_user/edit_user/${id}`,
    data: data,
    method: 'put'
  })
}

export const editCommentStrategy = (data, id) => {
  return axios.request({
    url: `dy_strategy/edit_comment_strategy/${id}`,
    data: data,
    method: 'put'
  })
}

export const userBlack = (data, id) => {
  return axios.request({
    url: `dy_user/black/${id}`,
    data: data,
    method: 'put'
  })
}

export const deleteCommentStrategy = (id) => {
  return axios.request({
    url: `dy_strategy/delete_comment_strategy/${id}`,
    method: 'delete'
  })
}

export const getStratedyRule = (params) => {
  return axios.request({
    url: 'dy/list_strategy_rule',
    params: params,
    method: 'get'
  })
}

export const get_char_data = (params) => {
  return axios.request({
    url: 'dy_video/get_char_data',
    params: params,
    method: 'get'
  })
}

export const get_classify_char_data = (params) => {
  return axios.request({
    url: 'dy_video/get_classify_char_data',
    params: params,
    method: 'get'
  })
}


export const get_user_video_data_list = (params) => {
  return axios.request({
    url: 'dy_video/get_user_video_data_list',
    params: params,
    method: 'get'
  })
}

export const get_user_classify_video_data_list = (params) => {
  return axios.request({
    url: 'dy_video/get_user_classify_video_data_list',
    params: params,
    method: 'get'
  })
}

export const getClassifyTag = (params) => {
  return axios.request({
    url: 'dy_user/list_tag',
    params: params,
    method: 'get'
  })
}

export const getGreeting = (params) => {
  return axios.request({
    url: 'dy/list_greeting',
    params: params,
    method: 'get'
  })
}

export const getCovertAudioList = (params) => {
  return axios.request({
    url: 'make_audio/list',
    params: params,
    method: 'get'
  })
}

export const device_list = (params) => {
  return axios.request({
    url: 'audio/device_list',
    params: params,
    method: 'get'
  })
}

// 新的base-version接口
export const baseVersionList = (params) => {
  return axios.request({
    url: 'base-version/list',
    params: params,
    method: 'get'
  })
}

export const getAllBaseVersions = () => {
  return axios.request({
    url: 'base-version/all',
    method: 'get'
  })
}

export const getBaseVersionById = (id) => {
  return axios.request({
    url: `base-version/${id}`,
    method: 'get'
  })
}

export const createBaseVersion = (data) => {
  return axios.request({
    url: 'base-version',
    data: data,
    method: 'post'
  })
}

export const updateBaseVersion = (id, data) => {
  return axios.request({
    url: `base-version/${id}`,
    data: data,
    method: 'put'
  })
}

export const deleteBaseVersion = (id) => {
  return axios.request({
    url: `base-version/${id}`,
    method: 'delete'
  })
}

export const getLatestBaseVersion = () => {
  return axios.request({
    url: 'base-version/latest',
    method: 'get'
  })
}

export const getVersionTypes = () => {
  return axios.request({
    url: 'base-version/version-types',
    method: 'get'
  })
}

// 保留旧接口以兼容现有代码
export const version_list = (params) => {
  return axios.request({
    url: 'version/list',
    params: params,
    method: 'get'
  })
}

export const version_type_list = (params) => {
  return axios.request({
    url: 'version/list_type',
    params: params,
    method: 'get'
  })
}


export const getCovertFaceList = (params) => {
  return axios.request({
    url: 'covert_face/list',
    params: params,
    method: 'get'
  })
}

export const getMergeVideoList = (params) => {
  return axios.request({
    url: 'merge_video/list',
    params: params,
    method: 'get'
  })
}

export const getAdvertisementVideoList = (params) => {
  return axios.request({
    url: 'advertisement_video/list',
    params: params,
    method: 'get'
  })
}

export const getShortVideoTaskList = (params) => {
  return axios.request({
    url: 'short_video_task/list',
    params: params,
    method: 'get'
  })
}

export const video_series_list = (params) => {
  return axios.request({
    url: 'short_video_task/video_series_list',
    params: params,
    method: 'get'
  })
}

export const getAdvertisementType = (params) => {
  return axios.request({
    url: 'short_video_task/advertisement_type',
    params: params,
    method: 'get'
  })
}

export const getPreAdvertisementTime = (params) => {
  return axios.request({
    url: 'short_video_task/get_pre_advertisement_time',
    params: params,
    method: 'get'
  })
}

export const getShortVideoWorkTypeList = (params) => {
  return axios.request({
    url: 'short_video_task/short_video_work_type_list',
    params: params,
    method: 'get'
  })
}

export const getGZLibrary = (params) => {
  return axios.request({
    url: 'short_video_task/gz_library',
    params: params,
    method: 'get'
  })
}

export const getAdvertisementLibrary = (params) => {
  return axios.request({
    url: 'short_video_task/advertisement_library',
    params: params,
    method: 'get'
  })
}

export const get_hj_library_list = (params) => {
  return axios.request({
    url: 'hj_library/list',
    params: params,
    method: 'get'
  })
}

export const mouth_library_list = (params) => {
  return axios.request({
    url: 'short_video_task/mouth_library_list',
    params: params,
    method: 'get'
  })
}

export const music_library_list = (params) => {
  return axios.request({
    url: 'short_video_task/music_library_list',
    params: params,
    method: 'get'
  })
}

export const getSceneList = (params) => {
  return axios.request({
    url: 'short_video_task/scene_video',
    params: params,
    method: 'get'
  })
}

export const music_library_classify = (params) => {
  return axios.request({
    url: 'short_video_task/music_library_classify',
    params: params,
    method: 'get'
  })
}

export const getStratedy = (params) => {
  return axios.request({
    url: 'dy/list_strategy',
    params: params,
    method: 'get'
  })
}

export const getStrategyUser = (params) => {
  return axios.request({
    url: 'dy_user/list_user',
    params: params,
    method: 'get'
  })
}

export const getLiveType = (params) => {
  return axios.request({
    url: 'dy_user/list_live_type',
    params: params,
    method: 'get'
  })
}

export const getShortVideoClassify = (params) => {
  return axios.request({
    url: 'short_video_task/short_video_classify',
    params: params,
    method: 'get'
  })
}

export const cookie_list = (params) => {
  return axios.request({
    url: 'short_video_task/cookie_list',
    params: params,
    method: 'get'
  })
}

export const hashtag_list = (params) => {
  return axios.request({
    url: 'short_video_task/hashtag_list',
    params: params,
    method: 'get'
  })
}

export const get_mouth_gpt_content_list = (params) => {
  return axios.request({
    url: 'check_srt_task/get_mouth_gpt_content_list',
    params: params,
    method: 'get'
  })
}


export const gz_library_classify = (params) => {
  return axios.request({
    url: 'short_video_task/gz_library_classify',
    params: params,
    method: 'get'
  })
}

export const getCheckSrtTaskList = (params) => {
  return axios.request({
    url: 'check_srt_task/list',
    params: params,
    method: 'get'
  })
}

export const getTaskList = (params) => {
  return axios.request({
    url: 'dy_task/list_task',
    params: params,
    method: 'get'
  })
}

export const videoList = (params) => {
  return axios.request({
    url: 'dy_video/list',
    params: params,
    method: 'get'
  })
}

export const audioModelList = (params) => {
  return axios.request({
    url: 'make_audio/audio_model_list',
    params: params,
    method: 'get'
  })
}

export const getTranslateTextList = (params) => {
  return axios.request({
    url: 'translate_text_task/list',
    params: params,
    method: 'get'
  })
}


export const  getTranslateTextDetail = (params) => {
  return axios.request({
    url: 'translate_text_task/detail',
    params: params,
    method: 'get'
  })
}

export const getCheckSrtDetail = (params) => {
  return axios.request({
    url: 'check_srt_task/detail',
    params: params,
    method: 'get'
  })
}

export const getCovertAudioDetail = (params) => {
  return axios.request({
    url: 'make_audio/detail',
    params: params,
    method: 'get'
  })
}

export const getStandUser = (params) => {
  return axios.request({
    url: 'short_video_task/stand_user_list',
    params: params,
    method: 'get'
  })
}

export const addStandUser = (data) => {
  return axios.request({
    url: 'short_video_task/add_stand_user',
    data: data,
    method: 'post'
  })
}

export const editStandUser = (data) => {
  return axios.request({
    url: 'short_video_task/edit_stand_user',
    data: data,
    method: 'post'
  })
}

export const add_video_series_list = (data) => {
  return axios.request({
    url: 'short_video_task/add_video_series_list',
    data: data,
    method: 'post'
  })
}

export const deleteStandUser = (id) => {
  return axios.request({
    url: `short_video_task/delete_stand_user/${id}`,
    method: 'delete'
  })
}

export const delete_version = (id) => {
  return axios.request({
    url: `version/delete/${id}`,
    method: 'delete'
  })
}

export const delete_path_version = (id) => {
  return axios.request({
    url: `version/delete_patch/${id}`,
    method: 'delete'
  })
}


export const delete_gz_library = (id) => {
  return axios.request({
    url: `short_video_task/delete_gz_library/${id}`,
    method: 'delete'
  })
}

export const delete_hj_library = (id) => {
  return axios.request({
    url: `hj_library/delete/${id}`,
    method: 'delete'
  })
}

export const delete_advertisement_library = (id) => {
  return axios.request({
    url: `short_video_task/delete_advertisement_library/${id}`,
    method: 'delete'
  })
}

export const version_add = (data) => {
  return axios.request({
    url: 'version/add',
    data: data,
    method: 'post'
  })
}

export const version_addBatch = (data) => {
  return axios.request({
    url: 'version/addBatch',
    data: data,
    method: 'post'
  })
}

export const version_batchUpdate = (data) => {
  return axios.request({
    url: 'aiqc-version/batch-update',
    data: data,
    method: 'post'
  })
}

export const model_batchUpdate = (data) => {
  return axios.request({
    url: 'aiqc-model-version/batch-update',
    data: data,
    method: 'post'
  })
}

export const version_patch_add = (data) => {
  return axios.request({
    url: 'version/add_patch',
    data: data,
    method: 'post'
  })
}



export const pushVideo = (data) => {
  return axios.request({
    url: 'dy_video/add',
    data: data,
    method: 'post'
  })
}

export const addDyUser = (data) => {
  return axios.request({
    url: 'dy_user/add_strategy_user_excel',
    data: data,
    method: 'post'
  })
}

export const resetCheck = (data) => {
  return axios.request({
    url: 'check_srt_task/reset_check',
    data: data,
    method: 'post'
  })
}

 export const  sendChatGpt = (data) => {
  return axios.request({
    url: 'short_video_task/sendChatGpt',
    data: data,
    method: 'post'
  })
}

export const  sendChatGptSystem = (data) => {
  return axios.request({
    url: 'short_video_task/sendChatGptSystem',
    data: data,
    method: 'post'
  })
}

export const deleteVideo = (data) => {
  return axios.request({
    url: 'dy_video/delete',
    data: data,
    method: 'post'
  })
}

export const deleteCovertAudio = (id) => {
  return axios.request({
    url: `video/delete_covert_audio/${id}`,
    method: 'delete'
  })
}

export const passShortVideo = (id) => {
  return axios.request({
    url: `short_video_task/pass/${id}`,
    method: 'put'
  })
}


export const edit_device = (id, data) => {
  return axios.request({
    url: `audio/edit_device/${id}`,
    data:data,
    method: 'put'
  })
}

export const updateDeviceFactory = (deviceId, factoryId) => {
  return axios.request({
    url: `audio/update_device_factory/${deviceId}?factor_id=${factoryId}`,
    method: 'put'
  })
}

export const edit_version = (data, id) => {
  return axios.request({
    url: `version/edit/${id}`,
    data:data,
    method: 'put'
  })
}

export const edit_patch_version = (id, data) => {
  return axios.request({
    url: `version/edit_patch/${id}`,
    data:data,
    method: 'put'
  })
}


export const endShortVideo = (id) => {
  return axios.request({
    url: `short_video_task/end_id/${id}`,
    method: 'put'
  })
}

export const edit_gz_library = (data, id) => {
  return axios.request({
    url: `short_video_task/edit_gz_library/${id}`,
    data: data,
    method: 'put'
  })
}

export const edit_hj_library = (data, id) => {
  return axios.request({
    url: `hj_library/edit/${id}`,
    data: data,
    method: 'put'
  })
}

export const edit_mouth_library = (data, id) => {
  return axios.request({
    url: `short_video_task/edit_mouth_library/${id}`,
    data: data,
    method: 'put'
  })
}

export const edit_music_library = (data, id) => {
  return axios.request({
    url: `short_video_task/edit_music_library/${id}`,
    data: data,
    method: 'put'
  })
}

export const edit_advertisement_library = (data, id) => {
  return axios.request({
    url: `short_video_task/edit_advertisement_library/${id}`,
    data: data,
    method: 'put'
  })
}

export const resetShortVideo = (id) => {
  return axios.request({
    url: `short_video_task/reset/${id}`,
    method: 'put'
  })
}

export const deleteShortVideo = (id) => {
  return axios.request({
    url: `short_video_task/delete/${id}`,
    method: 'delete'
  })
}

export const delete_mouth_library = (id) => {
  return axios.request({
    url: `short_video_task/delete_mouth_library/${id}`,
    method: 'delete'
  })
}

export const delete_music_library = (id) => {
  return axios.request({
    url: `short_video_task/delete_music_library/${id}`,
    method: 'delete'
  })
}

export const deleteCheckSrt = (id) => {
  return axios.request({
    url: `check_srt_task/delete/${id}`,
    method: 'delete'
  })
}

export const deleteTranslate = (id) => {
  return axios.request({
    url: `translate_text_task/delete/${id}`,
    method: 'delete'
  })
}

export const addCovertAudio = (data) => {
  return axios.request({
    url: 'make_audio/add',
    data: data,
    method: 'post'
  })
}

export const addShortVideoTask = (data) => {
  return axios.request({
    url: 'short_video_task/add',
    data: data,
    method: 'post'
  })
}

export const add_search_keyword = (data) => {
  return axios.request({
    url: 'short_video_task/add_search_keyword',
    data: data,
    method: 'post'
  })
}

export const editShortVideoTask = (data, id) => {
  return axios.request({
    url: `short_video_task/edit/${id}`,
    data: data,
    method: 'put'
  })
}

export const confirmShortVideoTask = (id) => {
  return axios.request({
    url: `short_video_task/confirm/${id}`,
    method: 'put'
  })
}


export const editCheckSrtTask = (data, id) => {
  return axios.request({
    url: `check_srt_task/edit/${id}`,
    data: data,
    method: 'put'
  })
}

export const editAdvertisementVideoTask = (data, id) => {
  return axios.request({
    url: `advertisement_video/edit/${id}`,
    data: data,
    method: 'put'
  })
}

export const editTranslateTextTask = (data, id) => {
  return axios.request({
    url: `translate_text_task/edit/${id}`,
    data: data,
    method: 'put'
  })
}


export const finishCheckSrtTask = (id) => {
  return axios.request({
    url: `check_srt_task/finish/${id}`,
    method: 'put'
  })
}

export const finishAdvertisementVideoTask = (id) => {
  return axios.request({
    url: `advertisement_video/finish/${id}`,
    method: 'put'
  })
}

export const finishMergeVideoTask = (id) => {
  return axios.request({
    url: `merge_video/finish/${id}`,
    method: 'put'
  })
}

export const finishCovertFaceTask = (id) => {
  return axios.request({
    url: `covert_face/finish/${id}`,
    method: 'put'
  })
}


export const finishTranslateTextTask = (id, data) => {
  return axios.request({
    url: `translate_text_task/finish/${id}`+ "?srt_json_path=" + data,
    method: 'put'
  })
}

export const finishCovertAudioTask = (id) => {
  return axios.request({
    url: `make_audio/finish/${id}`,
    method: 'put'
  })
}

export const deleteCovertAudioTask = (id) => {
  return axios.request({
    url: `make_audio/delete_covert_audio/${id}`,
    method: 'delete'
  })
}

export const editCovertAudioTask = (data, id) => {
  return axios.request({
    url: `make_audio/edit/${id}`,
    data: data,
    method: 'put'
  })
}

export const editCovertFaceTask = (data, id) => {
  return axios.request({
    url: `covert_face/edit/${id}`,
    data: data,
    method: 'put'
  })
}

export const editMergeVideoTask = (data, id) => {
  return axios.request({
    url: `merge_video/edit/${id}`,
    data: data,
    method: 'put'
  })
}


export const editPushVideo = (data, id) => {
  return axios.request({
    url: `dy_video/edit/${id}`,
    data: data,
    method: 'put'
  })
}

export const createTask = (data) => {
  return axios.request({
    url: 'dy_task/add_task',
    data: data,
    method: 'post'
  })
}

export const deleteTasks = (data) => {
  return axios.request({
    url: 'dy_task/delete_task',
    data: data,
    method: 'post'
  })
}

export const confirmTags = (data) => {
  return axios.request({
    url: 'dy_user/confirm_tags',
    data: data,
    method: 'post'
  })
}

export const deleteFollowers = (data) => {
  return axios.request({
    url:  'dy_user/delete_followers',
    data: data,
    method: 'post'
  })
}


export const addFactory = (data) => {
  return axios.request({
    url: 'factory/add',
    data: data,
    method: 'post'
  })
}

export const addClassify = (data) => {
  return axios.request({
    url: 'dy/add_classify',
    data: data,
    method: 'post'
  })
}

export const addClassifyTag = (data) => {
  return axios.request({
    url: 'dy_user/add_tag',
    data: data,
    method: 'post'
  })
}

export const editClassifyTag = (data, id) => {
  return axios.request({
    url: `dy_user/edit_tag/${id}`,
    data: data,
    method: 'put'
  })
}

export const deleteClassifyTag = (id) => {
  return axios.request({
    url: `dy_user/delete_tag/${id}`,
    method: 'delete'
  })
}

export const deleteWorkType = (id) => {
  return axios.request({
    url: `short_video_task/delete_work_type/${id}`,
    method: 'delete'
  })
}

export const delete_music_classify = (id) => {
  return axios.request({
    url: `short_video_task/delete_music_classify/${id}`,
    method: 'delete'
  })
}

export const deleteVideoType = (id) => {
  return axios.request({
    url: `short_video_task/delete_video_type/${id}`,
    method: 'delete'
  })
}

export const delete_cookie = (id) => {
  return axios.request({
    url: `short_video_task/delete_cookie/${id}`,
    method: 'delete'
  })
}

export const delete_hashtag = (id) => {
  return axios.request({
    url: `short_video_task/delete_hashtag/${id}`,
    method: 'delete'
  })
}

export const deleteScene= (id) => {
  return axios.request({
    url: `short_video_task/delete_scene/${id}`,
    method: 'delete'
  })
}

export const editScene = (data, id) => {
  return axios.request({
    url: `short_video_task/edit_scene/${id}`,
    data: data,
    method: 'put'
  })
}

export const editVideoType = (data, id) => {
  return axios.request({
    url: `short_video_task/edit_video_type/${id}`,
    data: data,
    method: 'put'
  })
}

export const edit_cookie = (data, id) => {
  return axios.request({
    url: `short_video_task/edit_cookie/${id}`,
    data: data,
    method: 'put'
  })
}

export const edit_hashtag = (data, id) => {
  return axios.request({
    url: `short_video_task/edit_hashtag/${id}`,
    data: data,
    method: 'put'
  })
}

export const edit_mouth_gpt_content = (data, id) => {
  return axios.request({
    url: `check_srt_task/edit_mouth_gpt_content/${id}`,
    data: data,
    method: 'put'
  })
}

export const editWorkType = (data, id) => {
  return axios.request({
    url: `short_video_task/edit_work_type/${id}`,
    data: data,
    method: 'put'
  })
}

export const edit_music_classify = (data, id) => {
  return axios.request({
    url: `short_video_task/edit_music_classify/${id}`,
    data: data,
    method: 'put'
  })
}

export const addScene = (data) => {
  return axios.request({
    url: 'short_video_task/add_scene',
    data: data,
    method: 'post'
  })
}

export const addWorkType = (data) => {
  return axios.request({
    url: 'short_video_task/add_work_type',
    data: data,
    method: 'post'
  })
}

export const add_music_classify = (data) => {
  return axios.request({
    url: 'short_video_task/add_music_classify',
    data: data,
    method: 'post'
  })
}

export const add_gz_library = (data) => {
  return axios.request({
    url: 'short_video_task/add_gz_library',
    data: data,
    method: 'post'
  })
}

export const add_hj_library = (data) => {
  return axios.request({
    url: 'hj_library/add',
    data: data,
    method: 'post'
  })
}


export const add_mouth_library = (data) => {
  return axios.request({
    url: 'short_video_task/add_mouth_library',
    data: data,
    method: 'post'
  })
}

export const add_music_library = (data) => {
  return axios.request({
    url: 'short_video_task/add_music_library',
    data: data,
    method: 'post'
  })
}


export const add_advertisement_library = (data) => {
  return axios.request({
    url: 'short_video_task/add_advertisement_library',
    data: data,
    method: 'post'
  })
}

export const addVideoType = (data) => {
  return axios.request({
    url: 'short_video_task/add_video_type',
    data: data,
    method: 'post'
  })
}

export const add_cookie = (data) => {
  return axios.request({
    url: 'short_video_task/add_cookie',
    data: data,
    method: 'post'
  })
}

export const add_hashtag = (data) => {
  return axios.request({
    url: 'short_video_task/add_hashtag',
    data: data,
    method: 'post'
  })
}

export const add_mouth_gpt_content = (data) => {
  return axios.request({
    url: 'check_srt_task/add_mouth_gpt_content',
    data: data,
    method: 'post'
  })
}


export const addTaskType = (data) => {
  return axios.request({
    url: 'dy_task/add_task_type',
    data: data,
    method: 'post'
  })
}

export const addActionType = (data) => {
  return axios.request({
    url: 'dy_task/add_action_type',
    data: data,
    method: 'post'
  })
}

export const deleteTaskType = (id) => {
  return axios.request({
    url: `dy_task/delete_task_type/${id}`,
    method: 'delete'
  })
}

export const deleteActionType = (id) => {
  return axios.request({
    url: `dy_task/delete_action_type/${id}`,
    method: 'delete'
  })
}

export const editTaskType = (data, id) => {
  return axios.request({
    url: `dy_task/edit_task_type/${id}`,
    data: data,
    method: 'put'
  })
}


export const editActionType = (data, id) => {
  return axios.request({
    url: `dy_task/edit_action_type/${id}`,
    data: data,
    method: 'put'
  })
}

export const addCommentRule = (data) => {
  return axios.request({
    url: 'dy/add_comment_rule',
    data: data,
    method: 'post'
  })
}

export const editCommentRule = (data, id) => {
  return axios.request({
    url: `dy/edit_strategy_rule/${id}`,
    data: data,
    method: 'put'
  })
}

export const deleteCommentRule = (id) => {
  return axios.request({
    url: `dy/delete_strategy_rule/${id}`,
    method: 'delete'
  })
}

export const addGpt = (data) => {
  return axios.request({
    url: 'dy/add_classify_gpt',
    data: data,
    method: 'post'
  })
}

export const delFactory = (id) => {
  return axios.request({
    url: `factory/delete/${id}`,
    method: 'delete'
  })
}

export const deleteClassify = (id) => {
  return axios.request({
    url: `dy/delete_classify/${id}`,
    method: 'delete'
  })
}

export const editFactory = (data) => {
  return axios.request({
    url: `factory/edit/${data.id}`,
    data: data,
    method: 'put'
  })
}

export const editClassify = (data, id) => {
  return axios.request({
    url: `dy/edit_classify/${id}`,
    data: data,
    method: 'put'
  })
}

export const getDeviceList = (page, pageSize, keyword, factoryId) => {
  return axios.request({
    url: 'device/list',
    params: {
      page,
      pageSize,
      keyword,
      factoryId
    },
    method: 'get'
  })
}

export const delete_search_keyword = (id) => {
  return axios.request({
    url: `short_video_task/delete_search_keyword/${id}`,
    method: 'delete'
  })
}

export const search_keyword_list = (data) => {
  return axios.request({
    url: 'short_video_task/search_keyword_list',
    params:data,
    method: 'get'
  })
}


export const getDeviceInfo = (id) => {
  return axios.request({
    url: 'device/info',
    params: {
      id
    },
    method: 'get'
  })
}

export const addDevice = (data) => {
  return axios.request({
    url: 'device/add',
    data: data,
    method: 'post'
  })
}

export const addAdvertisement = (data) => {
  return axios.request({
    url: 'dy/add_advertisement',
    data: data,
    method: 'post'
  })
}

export const addGreetings = (data) => {
  return axios.request({
    url: 'dy/add_greetings',
    data: data,
    method: 'post'
  })
}

export const editGreetings = (data, id) => {
  return axios.request({
    url: `dy/edit_greetings/${id}`,
    data: data,
    method: 'put'
  })
}

export const deleteGreeting = (id) => {
  return axios.request({
    url: `dy/delete_greetings/${id}`,
    method: 'delete'
  })
}

export const delDevice = (id) => {
  return axios.request({
    url: `device/delete/${id}`,
    method: 'delete'
  })
}

export const editGpt = (data, id) => {
  return axios.request({
    url: `dy/edit_classify_gpt/${id}`,
    data: data,
    method: 'put'
  })
}

export const editAdvertisement = (data, id) => {
  return axios.request({
    url: `dy/edit_advertisement/${id}`,
    data: data,
    method: 'put'
  })
}

export const deleteAdvertisement = (id) => {
  return axios.request({
    url: `dy/delete_advertisement/${id}`,
    method: 'delete'
  })
}


export const deleteGpt = (id) => {
  return axios.request({
    url: `dy/delete_classify_gpt/${id}`,
    method: 'delete'
  })
}

export const editDevice = (data) => {
  return axios.request({
    url: `device/edit/${data.id}`,
    data: data,
    method: 'put'
  })
}

export const searchSaleUser = (factoryId) => {
  return axios.request({
    url: 'user/list',
    params: {
      factoryId
    },
    method: 'get'
  })
}

export const getAllUser = () => {
  return axios.request({
    url: 'user/list',
    method: 'get'
  })
}

export const getUserList = (page, pageSize, keyword, factoryId) => {
  return axios.request({
    url: 'user/list',
    params: {
      page,
      pageSize,
      keyword,
      factoryId
    },
    method: 'get'
  })
}

export const getUserInfo = (id) => {
  return axios.request({
    url: 'user/info',
    params: {
      id
    },
    method: 'get'
  })
}

export const addUser = (data) => {
  return axios.request({
    url: 'user/add',
    data: data,
    method: 'post'
  })
}

export const delUser = (id) => {
  return axios.request({
    url: `user/delete/${id}`,
    method: 'delete'
  })
}

export const editUser = (data) => {
  return axios.request({
    url: `user/edit/${data.id}`,
    data: data,
    method: 'put'
  })
}

export const updateUserStatus = (data) => {
  return axios.request({
    url: 'user/updateUserStatus',
    data: data,
    method: 'post'
  })
}

export const getAllCustomer = () => {
  return axios.request({
    url: 'customer/list',
    method: 'get'
  })
}

export const getCustomerList = (page, pageSize, keyword, userId) => {
  return axios.request({
    url: 'customer/list',
    params: {
      page,
      pageSize,
      keyword,
      userId
    },
    method: 'get'
  })
}

export const getCustomerInfo = (id) => {
  return axios.request({
    url: 'customer/info',
    params: {
      id
    },
    method: 'get'
  })
}

export const addCustomer = (data) => {
  return axios.request({
    url: 'customer/add',
    data: data,
    method: 'post'
  })
}

export const delCustomer = (id) => {
  return axios.request({
    url: `customer/delete/${id}`,
    method: 'delete'
  })
}

export const editCustomer = (data) => {
  return axios.request({
    url: `customer/edit/${data.id}`,
    data: data,
    method: 'put'
  })
}

export const customerCode = (id) => {
  return axios.request({
    url: 'customer/makeCustomerQr',
    params: {
      id
    },
    method: 'get'
  })
}

export const customerUser = (params) => {
  return axios.request({
    url: 'customer/customerUser',
    params: params,
    method: 'get'
  })
}

export const downloadOrderExport = (ids) => {
  return axios.request({
    url: 'order/exportOrderList',
    params: {
      ids
    },
    method: 'get',
    paramsSerializer: function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  })
}

export const getOrderList = (page, pageSize, keyword, customerId, salesUserId, startTime, endTime, status) => {
  return axios.request({
    url: 'order/list',
    params: {
      page,
      pageSize,
      keyword,
      customerId,
      salesUserId,
      startTime,
      endTime,
      status
    },
    method: 'get'
  })
}

export const searchOrder = (orderNo) => {
  return axios.request({
    url: 'order/list',
    params: {
      orderNo: orderNo
    },
    method: 'get'
  })
}

export const getOrderInfo = (id) => {
  return axios.request({
    url: 'order/info',
    params: {
      id
    },
    method: 'get'
  })
}

export const addOrder = (data) => {
  return axios.request({
    url: 'order/add',
    data: data,
    method: 'post'
  })
}

export const delOrder = (id) => {
  return axios.request({
    url: `order/delete/${id}`,
    method: 'delete'
  })
}

export const editOrder = (data) => {
  return axios.request({
    url: `order/edit/${data.id}`,
    data: data,
    method: 'put'
  })
}

export const editUnitPrice = (data, id) => {
  return axios.request({
    url: `order/editUnitPrice/${id}`,
    data: data,
    method: 'put'
  })
}

export const cancelOrder = (id) => {
  return axios.request({
    url: `order/cancel/${id}`,
    method: 'put'
  })
}

export const confirmOrder = (id) => {
  return axios.request({
    url: `order/confirmOrder/${id}`,
    method: 'put'
  })
}

export const searchBatch = (params) => {
  return axios.request({
    url: 'batch/list',
    params: params,
    method: 'get'
  })
}

export const getBatchList = (page, pageSize, keyword, orderId, startTime, endTime, status) => {
  return axios.request({
    url: 'batch/list',
    params: {
      page,
      pageSize,
      keyword,
      orderId,
      startTime,
      endTime,
      status
    },
    method: 'get'
  })
}

export const getBatchInfo = (id) => {
  return axios.request({
    url: 'batch/info',
    params: {
      id
    },
    method: 'get'
  })
}

export const addBatch = (data) => {
  return axios.request({
    url: 'batch/add',
    data: data,
    method: 'post'
  })
}

export const delBatch = (id) => {
  return axios.request({
    url: `batch/delete/${id}`,
    method: 'delete'
  })
}

export const editBatch = (data) => {
  return axios.request({
    url: `batch/edit/${data.id}`,
    data: data,
    method: 'put'
  })
}

export const editBatchMoney = (id, data) => {
  return axios.request({
    url: `batch/editMoney/${id}`,
    data: data,
    method: 'put'
  })
}

export const editPayStatus = (data, id) => {
  return axios.request({
    url: `batch/payStatus/${id}`,
    data: data,
    method: 'put'
  })
}

export const editPayType = (data, id) => {
  return axios.request({
    url: `batch/payType/${id}`,
    data: data,
    method: 'put'
  })
}

export const downloadBatchShipment = (ids, type) => {
  return axios.request({
    url: 'batch/batchShipment',
    params: {
      ids: ids,
      type: type
    },
    method: 'get',
    paramsSerializer: function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  })
}

export const downloadBatchReport = (ids) => {
  return axios.request({
    url: 'batch/downloadBatchReport',
    params: {
      ids
    },
    method: 'get',
    paramsSerializer: function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  })
}

export const eventList = (params) => {
  return axios.request({
    url: 'event/list',
    params: params,
    method: 'get'
  })
}

export const downloadQr = (id, pieceId) => {
  return axios.request({
    url: 'batch/downloadQr',
    params: {
      id,
      pieceId
    },
    method: 'get'
  })
}

export const searchPiece = (params) => {
  return axios.request({
    url: 'piece/list',
    params: params,
    method: 'get'
  })
}

export const getPieceList = (page, pageSize, keyword, batchId, startTime, endTime, status) => {
  return axios.request({
    url: 'piece/list',
    params: {
      page,
      pageSize,
      keyword,
      batchId,
      startTime,
      endTime,
      status
    },
    method: 'get'
  })
}

export const getPieceInfo = (id) => {
  return axios.request({
    url: 'piece/info',
    params: {
      id
    },
    method: 'get'
  })
}

export const getPieceReport = (ids) => {
  return axios.request({
    url: 'piece/pieceReport',
    params: {
      ids: ids
    },
    method: 'get',
    paramsSerializer: function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  })
}

export const getPieceShipment = (ids, type) => {
  return axios.request({
    url: 'piece/shipment',
    params: {
      ids: ids,
      type: type
    },
    method: 'get',
    paramsSerializer: function (params) {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    }
  })
}

export const addPiece = (data) => {
  return axios.request({
    url: 'piece/add',
    data: data,
    method: 'post'
  })
}

export const delPiece = (id) => {
  return axios.request({
    url: `piece/delete/${id}`,
    method: 'delete'
  })
}

export const delPieces = (data) => {
  return axios.request({
    url: `piece/deletes`,
    data: data,
    method: 'delete'
  })
}

export const editPiece = (data) => {
  return axios.request({
    url: `piece/edit/${data.id}`,
    data: data,
    method: 'put'
  })
}

export const getRemarkList = (page, pageSize) => {
  return axios.request({
    url: 'remark/list',
    params: {
      page,
      pageSize,
    },
    method: 'get'
  })
}

export const getRemarkInfo = (id) => {
  return axios.request({
    url: 'remark/info',
    params: {
      id
    },
    method: 'get'
  })
}

export const addRemark = (data) => {
  return axios.request({
    url: 'remark/add',
    data: data,
    method: 'post'
  })
}

export const delRemark = (id) => {
  return axios.request({
    url: `remark/delete/${id}`,
    method: 'delete'
  })
}

export const editRemark = (data, id) => {
  return axios.request({
    url: `remark/edit/${id}`,
    data: data,
    method: 'put'
  })
}

export const getShipmentList = (params) => {
  return axios.request({
    url: 'shipment/list',
    params: params,
    method: 'get'
  })
}

export const addPieceShipment = (data) => {
  return axios.request({
    url: 'shipment/addPiece',
    data: data,
    method: 'post'
  })
}

export const delShipment = (id) => {
  return axios.request({
    url: `shipment/delete/${id}`,
    method: 'delete'
  })
}

export const deleteDyUser = (id) => {
  return axios.request({
    url: `dy_user/delete/${id}`,
    method: 'delete'
  })
}

export const exportShipment = (id) => {
  return axios.request({
    url: `shipment/exportShipment`,
    params: {
      id: id
    },
    method: 'get'
  })
}

export const exportSettlement = (id) => {
  return axios.request({
    url: `shipment/exportSettlement`,
    params: {
      id: id
    },
    method: 'get'
  })
}

export const editShipmentPayStatus = (id) => {
  return axios.request({
    url: `shipment/editStatus/${id}`,
    method: 'put'
  })
}

export const getTableData = () => {
  return axios.request({
    url: 'get_table_data',
    method: 'get'
  })
}

export const getDragList = () => {
  return axios.request({
    url: 'get_drag_list',
    method: 'get'
  })
}

export const errorReq = () => {
  return axios.request({
    url: 'error_url',
    method: 'post'
  })
}

export const saveErrorLogger = info => {
  return axios.request({
    url: 'save_error_logger',
    data: info,
    method: 'post'
  })
}

export const uploadImg = formData => {
  return axios.request({
    url: 'image/upload',
    data: formData
  })
}

export const getOrgData = () => {
  return axios.request({
    url: 'get_org_data',
    method: 'get'
  })
}

export const getTreeSelectData = () => {
  return axios.request({
    url: 'get_tree_select_data',
    method: 'get'
  })
}

export const error_logs_search = (params) => {
  return axios.request({
    url: 'error-logs/search',
    method: 'get',
    params
  })
}

export const error_logs_stack_traces = (errorId) => {
  return axios.request({
    url: `error-logs/${errorId}/stack-traces`,
    method: 'get'
  })
}

export const getMachineRunLogList = (params) => {
  return axios.request({
    url: 'machineRunLog/pageByDeviceAndDate',
    params: params,
    method: 'get'
  })
}

// 模型管理相关接口
export const getModelList = (page, pageSize, keyword) => {
  return axios.request({
    url: 'model/list',
    params: {
      page,
      pageSize,
      keyword
    },
    method: 'get'
  })
}

export const getModelInfo = (id) => {
  return axios.request({
    url: `model/info?id=${id}`,
    method: 'get'
  })
}

export const addModel = (data) => {
  return axios.request({
    url: 'model/add',
    data: data,
    method: 'post'
  })
}

export const editModel = (data) => {
  return axios.request({
    url: `model/edit/${data.id}`,
    data: data,
    method: 'put'
  })
}

export const delModel = (id) => {
  return axios.request({
    url: `model/delete/${id}`,
    method: 'delete'
  })
}

// 设备模型配置相关接口
export const getDeviceModelList = (page, pageSize, liveDeviceId) => {
  return axios.request({
    url: 'deviceToModel/list',
    params: {
      page,
      pageSize,
      liveDeviceId
    },
    method: 'get'
  })
}

export const updateDeviceModelConfig = (id, data) => {
  return axios.request({
    url: `deviceToModel/${id}`,
    data: data,
    method: 'put'
  })
}

export const batchSyncDeviceModel = (sourceLiveDeviceId, targetLiveDeviceIds, flawModelId) => {
  return axios.request({
    url: 'deviceToModel/batchSync',
    params: {
      sourceLiveDeviceId,
      targetLiveDeviceIds,
      flawModelId
    },
    method: 'post'
  })
}

export const updateDeviceFlawParams = (liveDeviceId, flawParamsJson) => {
  return axios.request({
    url: 'deviceToModel/updateFlawParams',
    data: {
      liveDeviceId,
      flawParamsJson
    },
    method: 'put'
  })
}

export const updateDeviceFlawParamsById = (id, flawParamsJson) => {
  return axios.request({
    url: 'deviceToModel/updateFlawParamsById',
    data: {
      id,
      flawParamsJson
    },
    method: 'put'
  })
}

// 获取设备验布信息列表
export const getLiveDeviceInfo = (params) => {
  return axios.request({
    url: 'live_device_info/list',
    params: params,
    method: 'get'
  })
}

// 设备基础配置相关接口
export const getDeviceConfig = (deviceId) => {
  return axios.request({
    url: `version/device/${deviceId}`,
    method: 'get'
  })
}

export const updateDeviceConfig = (deviceId, deviceConfigJson) => {
  return axios.request({
    url: `version/device/${deviceId}/config`,
    data: {
      device_config_json: deviceConfigJson
    },
    method: 'put'
  })
}

// AIQC版本管理相关接口
export const createAiqcVersion = (data) => {
  return axios.request({
    url: 'aiqc-version',
    data: data,
    method: 'post'
  })
}
